<template>
	<b-modal
		:title="title"
		ref="camera-capture-modal"
		@hidden="closeModal"
		hide-footer
		no-close-on-backdrop
		no-close-on-esc
		scrollable
	>
		<div class="d-flex flex-column align-items-center justify-content-center">
			<div
				v-if="!photo && !cameraActive"
				class="d-flex flex-column align-items-center justify-content-center"
				style="width: 350px; height: 280px; border: 2px dashed #ccc; border-radius: 8px"
			>
				<feather-icon icon="CameraIcon" size="48" class="mb-2" />
				<span class="text-muted">No hay imagen seleccionada</span>
			</div>
			<video v-if="cameraActive" ref="video" autoplay playsinline class="w-100"></video>
			<img :src="photo" v-if="photo && !cameraActive" class="mt-2" style="max-width: 100%; height: auto" />
			<canvas ref="canvas" class="w-100" style="display: none"></canvas>
			<div class="d-flex justify-content-between w-100">
				<button v-if="cameraActive" class="btn btn-danger mt-1" @click="closeCamera">
					<feather-icon icon="XIcon"></feather-icon>
					Cancelar
				</button>
				<button v-if="cameraActive" class="btn btn-info mt-1" @click="toggleCamera">
					<feather-icon icon="RefreshCwIcon" />
					Voltear cámara
				</button>
				<button v-if="cameraActive" class="btn btn-success mt-1" @click="capturePhoto">
					<feather-icon icon="CameraIcon"></feather-icon>
					Capturar
				</button>
			</div>
		</div>
		<div v-if="!cameraActive" class="w-100 mt-2">
			<b-button variant="outline-primary" class="w-100 mb-2" @click="openCamera">
				<feather-icon icon="CameraIcon" class="mr-1" />
				Tomar foto con cámara
			</b-button>
			<label class="btn btn-primary w-100 mb-2">
				<feather-icon icon="ImageIcon" class="mr-1" />
				Buscar imagen
				<input type="file" accept="image/*" @change="onFileChange" style="display: none" />
			</label>
			<b-button v-if="photo" variant="success" class="w-100 mb-2" @click="saveImage">
				<feather-icon icon="SaveIcon" class="mr-1" />
				Guardar
			</b-button>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: "CameraCaptureModal",
	props: {
		title: {
			type: String,
			default: "",
		},
		previewImage: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			cameraActive: false,
			photo: null,
			stream: null,
			cameraFacingMode: "environment",
		}
	},
	methods: {
		async saveImage() {
			const { isConfirmed } = await this.showConfirmSwal()
			if (!isConfirmed) return
			this.$emit("photo-captured", this.photo)
			this.closeModal()
		},
		closeModal() {
			this.$emit("close")
			this.photo = null
		},
		onFileChange(event) {
			const file = event.target.files[0]
			if (file) {
				const reader = new FileReader()
				reader.onload = (e) => {
					this.photo = e.target.result
				}
				reader.readAsDataURL(file)
			}
		},
		openCamera() {
			this.cameraActive = true
			const constraints = {
				video: { facingMode: this.cameraFacingMode },
			}
			navigator.mediaDevices
				.getUserMedia(constraints)
				.then((stream) => {
					this.stream = stream
					this.$refs.video.srcObject = stream
				})
				.catch(() => {
					this.cameraActive = false
					this.photo = null
					alert("No se pudo acceder a la cámara")
				})
		},
		capturePhoto() {
			const video = this.$refs.video
			const canvas = this.$refs.canvas
			const ctx = canvas.getContext("2d")
			canvas.width = video.videoWidth
			canvas.height = video.videoHeight
			ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
			this.photo = canvas.toDataURL("image/png")
			this.closeCamera()
		},
		closeCamera() {
			if (this.stream) {
				this.stream.getTracks().forEach((track) => track.stop())
				this.stream = null
			}
			this.cameraActive = false // Solo oculta el video
		},
		toggleCamera() {
			this.cameraFacingMode = this.cameraFacingMode === "environment" ? "user" : "environment"
			this.closeCamera()
			this.openCamera()
		},
	},
	beforeDestroy() {
		if (this.stream) {
			this.stream.getTracks().forEach((track) => track.stop())
		}
	},
	mounted() {
		if (this.previewImage) this.photo = this.previewImage
		this.$refs["camera-capture-modal"].toggle()
	},
}
</script>
